/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.createc_train_passing = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LucesTren.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_TRAIN_PASSING);
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_TRAIN_PASSING_TOOLTIP);
  },
};

Blockly.Blocks.createc_logic_compare_train = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    // String 'Boolean', no el constructor: en v13 el constructor Boolean no funciona como check.
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_COMPARE_TRAIN);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_COMPARE_TRAIN_COMMING, 'TrenViniendo'],
        [Blockly.Msg.LANG_COMPARE_TRAIN_PASSING, 'TrenPaso'],
      ]), 'STATE')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

// Usa LucesTren.png a propósito: no existe un ícono de barrera.
Blockly.Blocks.createc_retiro_barriers = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LucesTren.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_RETIRO_BARRIERS_UP, 'Comando_Barreras_Abrir'],
        [Blockly.Msg.LANG_RETIRO_BARRIERS_DOWN, 'Comando_Barreras_Cerrar'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RETIRO_BARRIERS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RETIRO_BARRIERS_TOOLTIP);
  },
};

Blockly.Blocks.createc_retiro_blinking_lights = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LucesTren.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RETIRO_BLINKING_LIGHTS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RETIRO_BLINKING_LIGHTS_TOOLTIP);
  },
};

Blockly.Blocks.createc_retiro_luminaria_zona2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LuzCalle.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_LUMINARIA_ZONA2).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUMINARIA_ZONA2_TOOLTIP);
  },
};

Blockly.Blocks.createc_retiro_train_frequency = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Tren.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_NAME_SANMARTIN, 'sanmartin'],
        [Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_NAME_MITRE, 'mitre'],
      ]), 'TRAIN');
    this.appendValueInput('TIMES').setCheck(Number)
      .appendField(Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_EVERY);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_SECONDS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_TOOLTIP);
  },
};

Blockly.Blocks.createc_retiro_train_service = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Tren.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_RETIRO_TRAIN_SERVICE_ON, 'ON'],
        [Blockly.Msg.LANG_RETIRO_TRAIN_SERVICE_OFF, 'OFF'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_RETIRO_TRAIN_SERVICE).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_NAME_SANMARTIN, 'sanmartin'],
        [Blockly.Msg.LANG_RETIRO_TRAIN_FREQUENCY_NAME_MITRE, 'mitre'],
      ]), 'TRAIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RETIRO_TRAIN_SERVICE_TOOLTIP);
  },
};
